import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseEditComponent } from './BaseEditComponent';

export abstract class BaseEditPopUpComponent extends BaseEditComponent {

	constructor() {
		super();
		
	}

	protected activeModal: NgbActiveModal;
	
	goBack() {
		this.closePopUp(null);
	}

	closePopUp(obj: any) {
		this.isSaving = false;
		if (this.activeModal) {
			this.activeModal.close(obj);
		}
    }
}
